import React, { Component } from "react";
import { Helmet } from "react-helmet";
import logo from "../../assets/logo.png";
import Navbar from "../Navbar/Navbar";
import FairPracticeCodeContent from "./FairPracticeCodeContent";
import BottomBar from "../BottomBar/BottomBar";
class FairPracticeCode extends Component {
  render() {
    return (
      <div id="fairpracticecode" className="main">
        <Helmet>
          <title>Fair Practice Code | MoneyMonk</title>
          <meta name="description" content="Read MoneyMonk's Fair Practice Code ensuring transparent and ethical lending as an RBI Registered NBFC." />
          <link rel="canonical" href="https://moneymonkapp.in/fairpracticecode" />
        </Helmet>
        <Navbar imageData={logo} />
        <FairPracticeCodeContent />
        <BottomBar />
      </div>
    );
  }
}

export default FairPracticeCode;
